"use client";

import { useAnalytics } from "@/lib/analytics/useAnalytics";

export const POWERED_BY_EXPERIMENT = {
  FLAG: "powered-by-button-content",
  VARIANT: "powered-by",
} as const;

export const usePoweredByExperiment = (): boolean => {
  const analytics = useAnalytics();
  const getFeatureFlag = analytics?.getFeatureFlag;
  if (typeof getFeatureFlag !== "function") {
    return false;
  }
  return getFeatureFlag(POWERED_BY_EXPERIMENT.FLAG) === POWERED_BY_EXPERIMENT.VARIANT;
};
